import { deleteOrganizationDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteOrganizationCallable = getCallable(
  deleteOrganizationDefinition,
);
